import React, { useRef } from "react";
import { Button, Container, NavLink } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { formatToDate, formatToMonth, formatToUSDateTime } from "../../utils/dateFormat";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FaRegClock } from "react-icons/fa";
import { Link } from "react-router-dom";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

export default function LatestEvents({ nextMonthUpcomingEvents, loading }) {
  const sliderRef = useRef(null);

  // console.log("Next month upcoming events: ", nextMonthUpcomingEvents);

  const settings = {
    centerMode: true,
    centerPadding: "100px",
    slidesToShow: 2.2,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    speed: 500,
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          centerPadding: "18%",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "15%",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: "12%",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="latest-events my-5 py-5">
      <Container>
        {/* Title Row */}
        <div className="d-flex justify-content-center text-center team-header mb-4">
          <div className="d-flex justify-content-center align-items-center flex-column ms-auto">
            <h2 className="team-title mb-2 h1">Latest Events</h2>
          </div>
          <NavLink as={Link} to="/events" className="view-all-link ms-auto">
            View All
          </NavLink>
        </div>

        <div className="position-relative latest-events-wrapper">
          {loading || !nextMonthUpcomingEvents ? (
            <div className="d-flex justify-content-center align-items-center">
              <Skeleton height={450} width={800} borderRadius={12} />
            </div>
          ) : (
            <Slider
              ref={sliderRef}
              {...settings}
              className="latest-events-slider"
            >
              {nextMonthUpcomingEvents.map((event) => (
                <div key={event._id} className="slider-item-wrapper">
                  <div className="event-carousel-card">
                    <img
                      src={`${IMAGE_BASEURL}${event.image_path}`}
                      alt={event.title}
                      className="event-slider-img"
                    />

                    {/* Date Badge */}
                    <div className="event-date-badge">
                      <div className="date-number">{formatToDate(event.start_date)}</div>
                      <div className="date-month">{formatToMonth(event.start_date)}</div>
                    </div>

                    {/* Event Details Card - Only visible on center slide */}
                    <div className="event-details-overlay">
                      <h4 className="event-overlay-title">{event.title}</h4>
                      <p className="event-overlay-price">
                        Passes from ${event.price}
                      </p>

                      <div className="event-overlay-info">
                        <div className="d-flex align-items-center mb-2">
                          <FaRegClock />
                          <span className="mx-2">{formatToUSDateTime(event.start_date)}</span>
                        </div>
                        <div className="d-flex align-items-center mb-3">
                          <HiOutlineLocationMarker />
                          <span className="mx-2">{event.venue}</span>
                        </div>
                      </div>

                      <Button className="btn-event-details">
                        PASSES & DETAILS
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          )
          }

          {/* Custom Navigation Arrows */}
          <button
            className="carousel-arrow carousel-arrow-left"
            onClick={() => sliderRef.current.slickPrev()}
            aria-label="Previous slide"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button
            className="carousel-arrow carousel-arrow-right"
            onClick={() => sliderRef.current.slickNext()}
            aria-label="Next slide"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </Container>
    </section>
  );
}
